import service from '@/utils/server';

const modName='/mdm/addr/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//添加数据
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

//删除数据
export const deleteData = data => {
  return service({
    url: modName + 'delete',
    method: 'post',
    data
  });
};

//修改数据
export const updateData = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};

//模板下载
export const downloadTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/' + data,
    method: 'post',
    data
  });
};

//导入数据
export const importData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'import',
    method: 'post',
    data
  });
};
//初始化修改
export const initEdit = data => {
  return service({
    url: modName + 'initEdit',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/mdm/addr/api/index.js